import { MapControlsInterface } from 'types/functions';

// Return type for SetMapAction
export interface SetMapReturn {
    type: string;
    payload: object;
}

export interface SetMapAction {
    (map: object): SetMapReturn;
}

export const setMapAction: SetMapAction = (map) => {
    return {
        type: 'SET_MAP',
        payload: map,
    };
};

// Return type for SetMapControlsAction
export interface SetMapControlsReturn {
    type: string;
    payload: MapControlsInterface;
}

export interface SetMapControlsAction {
    (mapControls: MapControlsInterface): SetMapControlsReturn;
}

export const setMapControlsAction: SetMapControlsAction = (mapControls) => {
    return {
        type: 'SET_MAP_CONTROLS',
        payload: mapControls,
    };
};

// Return type for SetPlaybackControlsAction
export interface SetPlaybackControlsReturn {
    type: string;
    payload: object;
}

export interface SetPlaybackControlsAction {
    (playbackControls: object): SetPlaybackControlsReturn;
}

export const setPlaybackControlsAction: SetPlaybackControlsAction = (playbackControls) => {
    return {
        type: 'SET_PLAYBACK_CONTROLS',
        payload: playbackControls,
    };
};

// Return type for SetOutlineIntervalAction
export interface SetOutlineIntervalReturn {
    type: string;
    payload: number;
}

export interface SetOutlineIntervalAction {
    (outlineInterval: number): SetOutlineIntervalReturn;
}

export const setOutlineIntervalAction: SetOutlineIntervalAction = (outlineInterval) => {
    return {
        type: 'SET_OUTLINE_INTERVAL',
        payload: outlineInterval,
    };
};
